const state = {
  isInit: false,
  logged: 0,
  user: {},
}

export default state
